import { render, staticRenderFns } from "./inventoryStockDetail.vue?vue&type=template&id=21ed80bb&scoped=true"
import script from "./inventoryStockDetail.vue?vue&type=script&lang=js"
export * from "./inventoryStockDetail.vue?vue&type=script&lang=js"
import style0 from "./inventoryStockDetail.vue?vue&type=style&index=0&id=21ed80bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed80bb",
  null
  
)

export default component.exports